import Component from '../abstracts/Component';

export default class NotifyMeComponent extends Component {
  get SELECTORS() {
    return {
      form: '.js-notify-me',
      actions: '.product-actions',
      container: '.js-form-container',
      cartBar: '.cart-bar',
      sizeLayer: '.size-layer'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
    };
  }

  constructor() {
    super();
    this.form = $(this.SELECTORS.form);
    this.actions = $(this.SELECTORS.actions);
    this.container = $(this.SELECTORS.container);
    this.cartBar = $(this.SELECTORS.cartBar);
    this.sizeLayer = $(this.SELECTORS.sizeLayer);
  }

  openForm(code) {
    $(`${this.SELECTORS.container}[data-code=${code}]`).addClass(this.CLASSES.show);
    if (this.$matchMedia('sm', null)) this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {classes: 'dark'});
  }

  enableForm(code, baseCode) {
    let form =  $(`${this.SELECTORS.container}[data-code="${baseCode}"]`).find(this.SELECTORS.form);
    let cta = form.find('.submit');
    form.find('#productcode').val(code);
    cta.data('disabled', false);
    cta.find('span').text(this.form.data('notifyMsg'));
  }

  bindEvents() {
  let ctx = this;

   $('body').on('submit', ctx.SELECTORS.form, function(e) {
      e.preventDefault();
      let $form = $(this);
      let url = $form.attr('action');
      let $submit = $form.find('.submit');
      let disabled = $form.find('button').data('disabled');
      let error = $form.find('.js-email-error');
      let notification = $form.data('selectMsg');

      if (disabled) {
        $form.closest(ctx.SELECTORS.container).addClass('select-size');
        $submit.find('span').text(notification);
      } else {
        if ($form.find('#email').val()) {
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
            button: $submit,
            loadertype: $submit.data('loadeLocal')
          })
        }

        $.ajax({
          type: "POST",
          url: url,
          data: $form.serialize(),
          success: function(message){
          ctx.log('successsssss');
            //$form.closest('.js-form-container').addClass('notify-message').text(message);

            ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: $submit} )
            if (ctx.$matchMedia('sm', null)) ctx.$emit(ctx.$customEvents.BACKDROP_EVENTS.hide);

            setTimeout(  () => {
              ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.disableButton)
              ctx.actions.removeClass(ctx.CLASSES.show);
              ctx.container.removeClass(ctx.CLASSES.show);
              ctx.cartBar.removeClass('show-size');
              ctx.sizeLayer.removeClass(ctx.CLASSES.show);
              error.addClass('hidden');
            }, 1000);

          },
          error: function(xhr){
            setTimeout(() => {
              ctx.log('notifyMe submit error ');
              error.removeClass('hidden').addClass('notify-message').text(xhr.responseText);
              $submit.removeClass('loading-cta');
              $form.find('[name="email"]').addClass('error')
              $form.find('.submit .js-pointers').removeClass('pointers');
              //TODO: HANDLING ERROR WHEN NO SIZE SELECTED
              }, 1000);
            }
        });
      }
    });

    //SET PRODUCT CODE TO INPUT ON SIZE CHANGE
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
      //remove size layer, set code and open notifyme
      let code = $(payload.button).data('code');
      let baseCode =  $(payload.button).data('baseCode');
      this.container.removeClass('select-size');
      //this.openForm(code);
      this.enableForm(code, baseCode);

      //if I select size from cart bar
      if ($(payload.button).closest('.cart-bar').length === 1) {
        if (!this.$matchMedia('sm', null)) {
          $("html, body").animate({ scrollTop: 0 });
        } else {
          //$('.js-form-container').addClass(this.CLASSES.show);
        }
      }
    });

    $('body').on('click.closeBackdrop','.js-form-container .js-close', function() {
      $(this).closest(ctx.SELECTORS.container).removeClass(ctx.CLASSES.show);
      if (ctx.$matchMedia('sm', null))  ctx.$emit(ctx.$customEvents.BACKDROP_EVENTS.hide);
    });
  }

  render() {
    this.bindEvents();
  }
}
